import axios from 'axios'
import { cancelPreviousRequest } from '../component/helper'

const API_URL = process.env.REACT_APP_THEME_API_URL
const USER_URL = `${API_URL}/user`
const GET_USERS_URL = `${API_URL}/users/query`


const EDIT_STATE_URL = `${API_URL}/showstate`
const SAVE_STATE_URL = `${API_URL}/savestate`
const GET_STATE_LIST = `${API_URL}/allstate`
const UPDATE_STATE = `${API_URL}/updatestate`


const GET_BANK_URL = `${API_URL}/allbank`
const SAVE_BANK_URL = `${API_URL}/savebank`
const EDIT_BANK_URL = `${API_URL}/showbank`
const UPDATE_BANK = `${API_URL}/updatebank`

const GET_COUNTRY_LIST = `${API_URL}/allcountry`
const SAVE_COUNTRY_URL = `${API_URL}/savecountry`
const EDIT_CONTRY_URL = `${API_URL}/universal-country-detail`
const UPDATE_CONTRY = `${API_URL}/updatecountry`

const EDIT_COM_URL = `${API_URL}/company-detail`

const SAVE_COM_URL = `${API_URL}/company-add`
const GET_COM_LIST = `${API_URL}/company-list`
//const COM_LOG = `${API_URL}/company-log`
const UPDATE_COM = `${API_URL}/company-edit`

const EDIT_PRO_URL = `${API_URL}/project-detail`

const SAVE_PRO_URL = `${API_URL}/project-add`
const GET_PRO_LIST = `${API_URL}/project-list`
//const PRO_LOG = `${API_URL}/project-log`
const UPDATE_PRO = `${API_URL}/project-edit`
const COM_SESSION = `${API_URL}/userloggedUpdate`

const MODULE_ADD = `${API_URL}/module-edit`
const MODULE_API_LIST = `${API_URL}/module-list`
const ROLE_LIST = `${API_URL}/role-detail`
const ROLE_ADD = `${API_URL}/rle-create`
const GET_PREM = `${API_URL}/get-perm`
const GET_ROLE_NAME = `${API_URL}/role-list`
const MODULES_WITH_REPORTS = `${API_URL}/modules-with-reports`
const ROLE_ACCESS = `${API_URL}/role-access`
const ROLE_ACCESS_SAVE = `${API_URL}/role-access-save`

const ALLCountryState = `${API_URL}/allCountryState`
const GET_RESPONER = `${API_URL}/alltrigger`
const EDIT_GET_RESPONER = `${API_URL}/showcommunication`
const UPDATE_RESPONER = `${API_URL}/updatecommunication`

const BRAND_ADD = `${API_URL}/brand-add`
const BRAND_LIST = `${API_URL}/brand-list`
const BRAND_EDIT = `${API_URL}/brand-edit`
const BRAND_BY_ID = `${API_URL}/brand-detail`

const ATTRIBUTE_ADD = `${API_URL}/attribute-add`
const ATTRIBUTE_LIST = `${API_URL}/attribute-list`
const ATTRIBUTE_EDIT = `${API_URL}/attribute-edit`
const ATTRIBUTE_BY_ID = `${API_URL}/attribute-detail`
const ATTRIBUTE_ALL = `${API_URL}/attribute-all-list`

const SEGMENT_ADD = `${API_URL}/business-segment-add`
const SEGMENT_LIST = `${API_URL}/business-and-sub-business-list`
const SEGMENT_EDIT = `${API_URL}/business-segment-edit`
const SEGMENT_BY_ID = `${API_URL}/business-segment-detail`

const BRAND_ALL = `${API_URL}/brand-all-list`
const BUSINESS_ALL = `${API_URL}/business-segment-all-list`
const SUB_BUSINESS_ALL = `${API_URL}/sub-business-segment-all-list`
const CATEGORY_ALL = `${API_URL}/category-all-list`
const SUB_CATEGORY_ALL = `${API_URL}/sub-category-all-list`
const CAT_ADD = `${API_URL}/category-add`
const CAT_LIST = `${API_URL}/category-and-sub-category-list`
const CAT_EDIT = `${API_URL}/category-edit`
const CAT_BY_ID = `${API_URL}/category-detail`

const PRODUCT_ALL = `${API_URL}/product-all-list`
const SUB_PRODUCT_ALL = `${API_URL}/sub-product-all-list`
const PRODUCT_ADD = `${API_URL}/product-add`
const PRODUCT_LIST = `${API_URL}/product-and-sub-product-list`
const PRODUCT_EDIT = `${API_URL}/product-edit`
const PRODUCT_BY_ID = `${API_URL}/product-detail`
const ALL_COM = `${API_URL}/all-company`
const PROJECT_COMPANY = `${API_URL}/project-com-list`

const SKU_ADD = `${API_URL}/sku-add`
const SKU_LIST = `${API_URL}/sku-list`
const PRO_SKU_LIST = `${API_URL}/project-sku-list`
const SKU_EDIT = `${API_URL}/sku-edit`
const SKU_BY_ID = `${API_URL}/sku-detail`
const ADD_PINCODE = `${API_URL}/add-pincode`
const MATCH_OTP = `${API_URL}/match-otp`
const SKU_CSV_DOWNLOAD = `${API_URL}/sku-download`
const SKU_TYPE = `${API_URL}/sku-type`
const GET_PRO_CLASS_LIST = `${API_URL}/pro-class-list`
const IIPRL_USER_ADD = `${API_URL}/iiprl-user-add`
const IIPRL_USER_UPDATE = `${API_URL}/iiprl-user-update`
const IIPRL_USER_LIST = `${API_URL}/iiprl-user-list`
const ALL_CAT_LIST = `${API_URL}/all-cat-list`
const CAT_ORDER_UPDATE = `${API_URL}/update-category-order`
const UPDATED_SETTINGS = `${API_URL}/project-setting`
const MODULE_SETTING = `${API_URL}/module-setting`

const BADGE_LIST = `${API_URL}/badge-list`
const EDIT_BADGE = `${API_URL}/edit-badge`
const BADGE_BY_ID = `${API_URL}/badge-detail`

const SUBCAT_BY_CAT = ` ${API_URL}/subcat-by-cat`
const UPDATE_USER_PASSWORD = `${API_URL}/update-user-pwd`
const ADD_TEST_USER_FOR_SKIP_REPORT = `${API_URL}/add-test-user-for-skip-report`
const REMOVE_TEST_USER_FOR_SKIP_REPORT = `${API_URL}/remove-test-user-for-skip-report`
const GET_TEST_USER_FOR_SKIP_REPORT = `${API_URL}/get-test-user-for-skip-report`
const GET_KYC_COUNTS = `${API_URL}/get-kyc-counts`

export const getKycCount = () => {
    return axios.get(`${GET_KYC_COUNTS}`).then((response) => response.data)
}

export const updateUserPassword = (current_password, password, password_confirmation) => {
    return axios.post(UPDATE_USER_PASSWORD, {
        current_password,
        password,
        password_confirmation,
    })
}

const getTeams = (query) => {
    return axios.get(`${GET_USERS_URL}?${query}`).then((d) => d.data)
}

const getUserById = (id) => {
    return axios
        .get(`${USER_URL}/${id}`)
        .then((response) => response.data)
    // .then((response) => response.data)
}
const createUser = (user) => {
    return axios
        .put(USER_URL, user)
        .then((response) => response.data)
}
const updateUser = (user) => {
    return axios
        .post(`${USER_URL}/${user.id}`, user)
        .then((response) => response.data)
    // .then((response) => response.data)
}

const updateCategory = (cat) => {
    return axios
        .post(`${USER_URL}/${cat.id}`, cat)
        .then((response) => response.data)
    // .then((response) => response.data)
}

const createCategory = (cat) => {
    return axios
        .put(USER_URL, cat)
        .then((response) => response.data)
}
const getAllBank = (query) => {
    return axios.get(`${GET_BANK_URL}?${query}`).then((d) => d.data)
}
const createBank = (data) => {
    return axios
        .post(SAVE_BANK_URL, data)
        .then((response) => response.data)

}

const getEditBankId = (id) => {
    return axios
        .get(`${EDIT_BANK_URL}/${id}`)
        .then((response) => response.data)
        .then((response) => response.data)
}
const updateBank = (query, id) => {
    return axios.post(`${UPDATE_BANK}/${id}`, query).then((response) => response.data)
}

const countryList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${GET_COUNTRY_LIST}?${query}`, { signal }).then((d) => d.data)
    // return axios.get(GET_COUNTRY_LIST, query).then((response) => response.data)
}
const getEditCountryId = (id) => {
    return axios
        .get(`${EDIT_CONTRY_URL}/${id}`)
        .then((response) => response.data)
        .then((response) => response.data)
}
const getEditStateId = (id) => {
    return axios
        .get(`${EDIT_STATE_URL}/${id}`)
        .then((response) => response.data)
        .then((response) => response.data)
}


const stateList = (query) => {
    return axios.get(`${GET_STATE_LIST}?${query}`).then((d) => d.data)
    // return axios.get(GET_STATE_LIST, query).then((response) => response.data)
}

const saveState = (query) => {
    return axios.post(SAVE_STATE_URL, query).then((response) => response.data)
}
const updateState = (query) => {
    return axios.post(`${UPDATE_STATE}/${query.id}`, query).then((response) => response.data)
}

const saveCountry = (query) => {
    return axios.post(SAVE_COUNTRY_URL, query).then((response) => response.data)
}
const updateCountry = (query, id) => {
    return axios.post(`${UPDATE_CONTRY}/${id}`, query).then((response) => response.data)
}

const allCountryState = (query) => {
    return axios.get(`${ALLCountryState}?${query}`).then((d) => d.data)
    // return axios.get(GET_STATE_LIST, query).then((response) => response.data)
}

const saveComapny = (query) => {
    return axios.post(SAVE_COM_URL, query).then((response) => response.data)
}

const updateCompany = (query) => {
    return axios.post(`${UPDATE_COM}`, query).then((response) => response.data)
}
const getPincodeSearch = (pincode) => {
    return axios
        .get(`https://api.postalpincode.in/pincode/${pincode}`)
        .then((response) => response.data)
        .then((response) => response.data)
}
// const addPincode = (query) => {
//     return axios.post(`${UPDATE_COM}`, query).then((response) => response.data)
// }
const getEditCompanyId = (id) => {
    return axios
        .get(`${EDIT_COM_URL}/${id}`)
        .then((response) => response.data)
        .then((response) => response.data)
}
const compantList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${GET_COM_LIST}?${query}`, { signal }).then((d) => d.data)
    // return axios.get(GET_STATE_LIST, query).then((response) => response.data)
}
// Sales Executive Visit API
const SALES_EXECUTIVE_VISIT_LIST = `${API_URL}/sales-executive-visits`
export const salesExecutiveVisitList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${SALES_EXECUTIVE_VISIT_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const allCompany = (query) => {
    return axios.get(ALL_COM).then((d) => d.data)
    // return axios.get(GET_STATE_LIST, query).then((response) => response.data)
}
export const saveProject = (query) => {
    return axios.post(SAVE_PRO_URL, query).then((response) => response.data)
}
export const updateProject = (query) => {

    return axios.post(`${UPDATE_PRO}`, query).then((response) => response.data)
}
export const updateProjectSettings = (query) => {

    return axios.post(UPDATED_SETTINGS, query).then((response) => response.data)
}

/** Common save for project config module settings by type (admin_portal, client_portal, ...) */
export const saveModuleSetting = (query) => {
    return axios.post(MODULE_SETTING, query).then((response) => response.data)
}

export const projectList = (query) => {

    const signal = cancelPreviousRequest()
    return axios.get(`${GET_PRO_LIST}?${query}`, { signal }).then((d) => d.data)
    // return axios.get(GET_STATE_LIST, query).then((response) => response.data)
}
export const projectClassList = (query) => {
    return axios.get(`${GET_PRO_CLASS_LIST}?${query}`).then((d) => d.data)
    // return axios.get(GET_STATE_LIST, query).then((response) => response.data)
}
export const projectCompanyList = (query) => {
    return axios.get(`${PROJECT_COMPANY}?${query}`).then((d) => d.data)
    // return axios.get(GET_STATE_LIST, query).then((response) => response.data)
}



export const getEditProjectId = (id) => {
    return axios
        .get(`${EDIT_PRO_URL}/${id}`)
        .then((response) => response.data)
        .then((response) => response.data)
}
const moduleAdd = (query) => {
    return axios.post(`${MODULE_ADD}`, query).then((response) => response.data)
}
const moduleUpdate = (query) => {
    return axios.post(`${MODULE_ADD}`, query).then((response) => response.data)
}
const moduleList = (query) => {
    return axios.post(`${MODULE_API_LIST}?${query}`).then((d) => d.data)

}
const roleList = () => {
    return axios.get(`${ROLE_LIST}`).then((d) => d.data)
}
const roleDetail = (query) => {
    return axios.get(`${ROLE_LIST}/${query}`).then((d) => d.data)
}

const addRole = (query) => {
    return axios.post(ROLE_ADD, query).then((d) => d.data)
}
const getPrem = (query) => {
    return axios.get(GET_PREM).then((d) => d.data)
}

const getRoleName = (query) => {
    // const signal = cancelPreviousRequest()
    return axios.get(GET_ROLE_NAME).then((d) => d.data)
}

/** Modules catalog with nested reports for Role & Report Assignment */
const modulesWithReports = (params = {}) => {
    return axios.get(MODULES_WITH_REPORTS, { params }).then((d) => d.data)
}

/** Role access detail (modules + actions + report_ids) */
const roleAccessDetail = (roleId, params = {}) => {
    return axios.get(`${ROLE_ACCESS}/${roleId}`, { params }).then((d) => d.data)
}

/** Save role modules (actions) and report ids independently */
const saveRoleAccess = (payload) => {
    return axios.post(ROLE_ACCESS_SAVE, payload).then((d) => d.data)
}


const getAutoResponder = () => {
    return axios.get(`${GET_RESPONER}`).then((d) => d.data)
}
const editAutoResponder = (id) => {
    return axios.get(`${EDIT_GET_RESPONER}/${id}`).then((d) => d.data).then((d) => d.data)
}
const updateAutoResponder = (query, id) => {
    return axios.post(`${UPDATE_RESPONER}/${id}`, query).then((response) => response.data)
}


/* product api */
const brandadd = (query) => {
    return axios.post(BRAND_ADD, query).then((d) => d.data)

}
const brandUpdate = (query) => {
    return axios.post(BRAND_EDIT, query).then((d) => d.data)
}
const brandList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${BRAND_LIST}?${query}`, { signal }).then((d) => d.data)
}
const getBrandbyId = (id) => {
    return axios.get(`${BRAND_BY_ID}/${id}`).then((response) => response.data?.data)
}

const attributeAdd = (query) => {
    return axios.post(ATTRIBUTE_ADD, query).then((d) => d.data)
}
const attributeUpdate = (query) => {
    return axios.post(ATTRIBUTE_EDIT, query).then((d) => d.data)
}
const attributeList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${ATTRIBUTE_LIST}?${query}`, { signal }).then((d) => d.data)
}
const getAttributeById = (id) => {
    return axios.get(`${ATTRIBUTE_BY_ID}/${id}`).then((response) => response.data?.data)
}
const attributeAll = () => {
    return axios.get(`${ATTRIBUTE_ALL}`).then((response) => response?.data?.data)
}

const segmentAdd = (query) => {
    return axios.post(SEGMENT_ADD, query).then((d) => d.data)
}
const segmentList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${SEGMENT_LIST}?${query}`, { signal }).then((d) => d.data)
}
const segmentUpdate = (query) => {
    return axios.post(SEGMENT_EDIT, query).then((d) => d.data)
}
const segmentGetById = (id) => {
    return axios.get(`${SEGMENT_BY_ID}/${id}`).then((d) => d.data?.data)
}


const buisnessAll = (query) => {
    return axios.post(`${BUSINESS_ALL}`, query).then((response) => response?.data?.data);
}
const subBuisnessAll = (query) => {
    return axios.post(`${SUB_BUSINESS_ALL}`, query).then((response) => response?.data?.data);
}
const brandAll = () => {
    return axios.get(`${BRAND_ALL}`).then((response) => response?.data?.data);
}
const categoryAll = (query) => {
    return axios.post(`${CATEGORY_ALL}`, query).then((response) => response?.data?.data);
}
const subCatAll = (query) => {
    return axios.post(`${SUB_CATEGORY_ALL}`, query).then((response) => response?.data?.data);
}
const subproductAll = (query) => {
    return axios.post(`${SUB_PRODUCT_ALL}`, query).then((response) => response?.data?.data);
}

const categoryAdd = (query) => {
    return axios.post(CAT_ADD, query).then((d) => d.data)

}

const categoryUpdate = (query) => {
    return axios.post(CAT_EDIT, query).then((d) => d.data)
}

export const categoryOrderUpdate = (query) => {
    return axios.post(CAT_ORDER_UPDATE, query).then((d) => d.data)
}

const categoryList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${CAT_LIST}?${query}`, { signal }).then((d) => d.data)
}

const getCategorybyId = (id) => {
    return axios.get(`${CAT_BY_ID}/${id}`).then((response) => response.data?.data)
}

const productAll = (query) => {
    return axios.post(`${PRODUCT_ALL}`, query).then((response) => response?.data?.data);
}

const productAdd = (query) => {
    return axios.post(PRODUCT_ADD, query).then((d) => d.data)

}

const productUpdate = (query) => {
    return axios.post(PRODUCT_EDIT, query).then((d) => d.data)
}

const productList = (query) => {
    return axios.get(`${PRODUCT_LIST}?${query}`).then((d) => d.data)
}

const getProductbyId = (id) => {
    return axios.get(`${PRODUCT_BY_ID}/${id}`).then((response) => response.data?.data)
}

/* product end */
const skuAdd = (query) => {
    return axios.post(SKU_ADD, query).then((d) => d.data)

}
const iiprlUserAdd = (query) => {
    return axios.post(IIPRL_USER_ADD, query).then((d) => d.data)
}
const iiprlUserUpdate = (query) => {
    return axios.post(IIPRL_USER_UPDATE, query).then((d) => d.data)
}
const iiprlUserList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${IIPRL_USER_LIST}?${query}`, { signal }).then((d) => d.data)

}


const skuUpdate = (query) => {
    return axios.post(SKU_EDIT, query).then((d) => d.data)
}

const skuList = (query) => {
    return axios.get(`${SKU_LIST}?${query}`).then((d) => d.data)
}
export const skuType = (query) => {
    return axios.get(`${SKU_TYPE}?${query}`).then((d) => d.data.data)
}


export const projectSkuList = (query) => {
    return axios.get(`${PRO_SKU_LIST}?${query}`).then((d) => d.data)
}

const getSkuId = (id) => {
    return axios.get(`${SKU_BY_ID}/${id}`).then((response) => response.data?.data)
}

export const companySession = (company_id, project_id) => {
    return axios.get(`${COM_SESSION}/${company_id}/${project_id}`).then((response) => response.data)
}

const addPincodes = (query) => {
    return axios.post(ADD_PINCODE, query).then((d) => d.data)
}

export const matchOTP = (query) => {
    return axios.post(MATCH_OTP, query).then((d) => d)
}

export const skuCsvDownload = () => {
    return axios.get(`${SKU_CSV_DOWNLOAD}`).then((response) => response.data)
}
export const userPincodeDownload = () => {
    return axios.get(`${SKU_CSV_DOWNLOAD}`).then((response) => response.data)
}
const allCatList = (query) => {
    return axios.get(`${ALL_CAT_LIST}?${query}`).then((d) => d.data)
}
const subCatByCat = (query) => {
    return axios.post(SUBCAT_BY_CAT, query).then((d) => d.data)


}
export const getBadgeList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${BADGE_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const getBadgeById = (query) => {
    return axios.post(`${BADGE_BY_ID}`, query).then((response) => response.data.data)
}
export const updateBadge = (query) => {
    return axios.post(`${EDIT_BADGE}`, query).then((response) => response.data)
}
export const addTestUserForSkipReport = (query) => {
    return axios.post(ADD_TEST_USER_FOR_SKIP_REPORT, query).then((response) => response.data)
}
export const removeTestUserForSkipReport = (query) => {
    return axios.post(REMOVE_TEST_USER_FOR_SKIP_REPORT, query).then((response) => response.data)
}
export const getTestUserForSkipReport = (query) => {
    return axios.post(GET_TEST_USER_FOR_SKIP_REPORT, query).then((response) => response.data)
}
export {
    addPincodes, createBank, getAllBank, getEditBankId,
    updateCategory, createCategory, getTeams,
    getUserById, createUser, updateUser,
    countryList, stateList, saveCountry, saveState,
    compantList, saveComapny, getEditCountryId,
    getEditStateId, getEditCompanyId, updateBank,
    updateCompany, updateState, updateCountry,
    allCountryState, getAutoResponder, editAutoResponder,
    updateAutoResponder, moduleAdd, moduleUpdate, moduleList, roleList,
    brandadd, brandList, brandUpdate, getBrandbyId, roleDetail, segmentList, segmentAdd, segmentUpdate,
    segmentGetById, buisnessAll, brandAll, categoryAll, subCatAll,
    categoryAdd, categoryUpdate, categoryList, getCategorybyId, subBuisnessAll,
    getProductbyId, productList, productUpdate, productAdd, productAll, subproductAll,
    skuAdd, skuUpdate, skuList, getSkuId, getPincodeSearch, addRole, getPrem, getRoleName, iiprlUserAdd, iiprlUserUpdate, iiprlUserList, allCatList, subCatByCat,
    attributeAdd, attributeUpdate, attributeList, getAttributeById, attributeAll,
    modulesWithReports, roleAccessDetail, saveRoleAccess
}